import React from 'react';

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function LegalMarkdown({ content }: { content: string }) {
  const lines = content.split(/\r?\n/);
  const parts: string[] = [];
  let i = 0;
  const inline = (s: string) =>
    escapeHtml(s).replace(/\*\*([^*]+)\*\*/g, (_, g) => '<strong>' + escapeHtml(g) + '</strong>');
  while (i < lines.length) {
    const line = lines[i];
    if (/^### /.test(line)) {
      parts.push(`<h3>${inline(line.replace(/^### /, ''))}</h3>`);
      i++;
    } else if (/^## /.test(line)) {
      parts.push(`<h2>${inline(line.replace(/^## /, ''))}</h2>`);
      i++;
    } else if (/^# /.test(line)) {
      parts.push(`<h1>${inline(line.replace(/^# /, ''))}</h1>`);
      i++;
    } else if (/^\s*[-*] /.test(line) || /^\d+\. /.test(line)) {
      parts.push(`<li>${inline(line.replace(/^\s*[-*]\s|\d+\.\s/, ''))}</li>`);
      i++;
    } else if (line.trim() === '') {
      if (parts[parts.length - 1]?.startsWith('<li>')) parts.push('</ul>');
      i++;
    } else {
      if (parts[parts.length - 1]?.startsWith('<li>')) parts.push('</ul>');
      parts.push(`<p>${inline(line)}</p>`);
      i++;
    }
  }
  if (parts[parts.length - 1]?.startsWith('<li>')) parts.push('</ul>');
  let html = parts.join('');
  // Consecutive <li> tek bir <ul> içinde olmalı: </p><li> → </p><ul><li>, </li><p> → </li></ul><p>
  html = html.replace(/<\/p><li>/g, '</p><ul><li>').replace(/<\/li><p>/g, '</li></ul><p>');
  if (html.endsWith('</li>')) html += '</ul>';
  return <div className="legal-body" dangerouslySetInnerHTML={{ __html: html }} />;
}

export const legalStyles = `
  .legal-wrap { min-height: 100vh; padding-bottom: 3rem; }
  .nav-simple { display: flex; justify-content: space-between; align-items: center; padding: 1rem 2rem; border-bottom: 1px solid var(--border); }
  .nav-simple a { font-size: 1.25rem; font-weight: 700; }
  .legal-content { max-width: 720px; margin: 0 auto; padding: 2rem 1.5rem; line-height: 1.7; }
  .legal-content h1 { margin: 0 0 1.5rem; font-size: 1.75rem; }
  .legal-error { color: #ff6b6b; }
  .legal-fallback { color: var(--text-secondary); }
  .legal-fallback a { color: var(--accent); }
  .legal-body h1, .legal-body h2, .legal-body h3 { color: var(--text-primary); margin: 1.25rem 0 0.5rem; }
  .legal-body h1 { font-size: 1.35rem; }
  .legal-body h2 { font-size: 1.2rem; }
  .legal-body h3 { font-size: 1.05rem; }
  .legal-body p { margin: 0.5rem 0; color: var(--text-secondary); }
  .legal-body strong { color: var(--text-primary); }
  .legal-body ul { margin: 0.5rem 0; padding-left: 1.5rem; color: var(--text-secondary); }
`;
